import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerFeeWallets } from 'services/CustomerService'
import { GetCustomerFeeWalletsResponse } from 'types/customers'

export const useCustomerFeeWalletsQuery = (enabled = true) => {
  return useQuery<GetCustomerFeeWalletsResponse>({
    queryKey: reactQueryKeys.customerFeeWallets(),
    queryFn: () => getCustomerFeeWallets(),
    enabled,
  })
}
